<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">Authentification CPX</div>
    <div class="modal-body" [ngClass]="{ 'loading': isLoading }">

      <div class="more-infos" *ngIf="moreInfoOnLoginNeed && moreInfoOnLoginNeed !== ''">
        <div>{{ moreInfoOnLoginNeed }}</div>
      </div>

      <!-- Si aucune carte CPX trouvée -->
      <ng-container *ngIf="currentState === currentStateTpt.noCpxCard">
        <div class="no-card-wrapper">
          <div class="no-card-message">
            Aucune carte CPX détectée.
            <br>
            Veuillez insérer une carte et essayer de nouveau.
          </div>

          <div class="button-container center">
            <frg-button (activated)="closeModal()" backgroundColor="var(--darkest-primary)">
              <div title="Fermer">Fermer</div>
            </frg-button>
            <frg-button (activated)="findCpxCard()">
              <div title="Réessayer">Réessayer</div>
            </frg-button>
          </div>
        </div>
      </ng-container>

      <!-- Si carte arrachée -->
      <ng-container *ngIf="currentState === currentStateTpt.rippedCard">
        <div class="no-card-wrapper">
          <div class="no-card-message">
            La carte a été arrachée.
            <br>
            Veuillez l'insérer de nouveau et réessayer.
          </div>

          <div class="button-container center">
            <frg-button (activated)="closeModal()" backgroundColor="var(--darkest-primary)">
              <div title="Fermer">Fermer</div>
            </frg-button>
            <frg-button (activated)="findCpxCard()">
              <div title="Réessayer">Réessayer</div>
            </frg-button>
          </div>
        </div>
      </ng-container>

      <!-- Si plusieurs slot on en sélectionne un -->
      <ng-container *ngIf="currentState === currentStateTpt.selectSlot">
        <app-select-slot
          [cpxCards]="multipleCpxCards"
          (selectCard)="selectCpxCard($event)"
          [closeModalFunction]="closeModal.bind(this)"
        ></app-select-slot>
      </ng-container>

      <!-- Affichage clavier code PIN -->
      <ng-container *ngIf="currentState === currentStateTpt.pinKeyboard">
        <div class="info-pin">Entrez le code PIN de votre carte de professionnel de santé</div>

        <form (ngSubmit)="readCard(formGroupPinCode.get('pinCode').value)">
          <frg-form-input
            [formGroup]="formGroupPinCode"
            [control]="formGroupPinCode.get('pinCode')"
            id="pinCode"
            type="password"
          ></frg-form-input>

          <div class="wrong-pin-code" *ngIf="isErrorWrongPin">Mauvais code PIN.<br>Veuillez réessayer.</div>

          <div class="button-container center">
            <frg-button (click)="closeModal()">
              <div title="Annuler">Annuler</div>
            </frg-button>
            <frg-button type="'submit'" [disabled]="!formGroupPinCode.valid">
              <div title="Valider">Valider</div>
            </frg-button>
          </div>
        </form>
      </ng-container>

      <!-- Sélection du cabinet d'exercice -->
      <ng-container *ngIf="currentState === currentStateTpt.selectPracticeLocation">
        <ng-container *ngIf="cpxType !== cpxTypeTpl.CPF">
          <app-select-practice-location
            [practiceLocations]="practiceLocations"
            [showUnautorizedMessage]="isUnautorizedPracticeLocation"
            (selectLocation)="selectPracticeSetting($event)"
            (cancelSelection)="closeModal()"
          ></app-select-practice-location>
        </ng-container>
        <ng-container *ngIf="cpxType === cpxTypeTpl.CPF">
          <div class="cpf-explain">Vous devez renseigner une situation pour vous connecter avec votre carte CPF.<br>Les informations ci-dessous sont pré-rempli selon les informations connues de votre profil.</div>
          <form (ngSubmit)="setPracticeSetting()">
            <ng-container *ngIf="cpfForm?.get('speciality')">
              <frg-form-input
                label="Spécialité"
                type="ngSelect"
                [isClearableSelect]="false"
                [selectValue]="specialitiescodes"
                [formGroup]="cpfForm"
                [control]="cpfForm.get('speciality')"
                id="speciality"
                isParentModal="true"
              ></frg-form-input>
            </ng-container>
            <frg-form-input
              label="Nom de la structure"
              type="text"
              [isClearableSelect]="false"
              [formGroup]="cpfForm"
              [control]="cpfForm.get('nomStructure')"
              id="nomStructure"
              isParentModal="true"
            ></frg-form-input>
            <frg-form-input
              label="Identifiant National Structure"
              type="text"
              [isClearableSelect]="false"
              [formGroup]="cpfForm"
              [control]="cpfForm.get('idNatStructure')"
              id="idNatStructure"
              isParentModal="true"
            ></frg-form-input>
            <frg-form-input
              label="Type Structure"
              type="ngSelect"
              [isClearableSelect]="false"
              [selectValue]="healthcarefacilitytypecodes"
              [formGroup]="cpfForm"
              [control]="cpfForm.get('typeStructure')"
              id="typeStructure"
              isParentModal="true"
            ></frg-form-input>
            <frg-form-input
              label="Type d'activité"
              type="ngSelect"
              [isClearableSelect]="false"
              [selectValue]="practicesettingcodes"
              [formGroup]="cpfForm"
              [control]="cpfForm.get('activite')"
              id="activite"
              isParentModal="true"
            ></frg-form-input>

            <div class="button-container center">
              <frg-button type="'submit'" [disabled]="!cpfForm.valid">
                <div title="Valider">Valider</div>
              </frg-button>
            </div>
          </form>
        </ng-container>
      </ng-container>

      <!-- Message code PIN valide (quelques secondes puis la modal se ferme) -->
      <ng-container *ngIf="currentState === currentStateTpt.confirmationMessage">
        <div class="valid-pin">Code PIN valide</div>
      </ng-container>

      <!-- S'il on arrive pas à contacter le serveur DMPConnect -->
      <ng-container *ngIf="currentState === currentStateTpt.unableToOpenSession">
        <div class="no-card-wrapper">
          <div class="no-card-message">
            Impossible de se connecter au service DMPConnect.
            <br>
            Vérifiez que le service DMPConnect est bien en cours de fonctionnement.
            <br>
            <br>
            (Si le service DMPConnect vient d'être lancé et que vous voyez ce message, veuillez attendre quelques instants, puis ré-essayez de nouveau.)
          </div>
        </div>
        <div class="button-container center">
          <frg-button (activated)="closeModal()" backgroundColor="var(--darkest-primary)">
            <div title="Fermer">Fermer</div>
          </frg-button>
        </div>
      </ng-container>

      <!-- La carte insérée est expirée -->
      <ng-container *ngIf="currentState === currentStateTpt.expiredCard">
        <div class="no-card-wrapper">
          <div class="no-card-message">La carte insérée est expirée.</div>
        </div>
        <div class="button-container center">
          <frg-button (activated)="closeModal()" backgroundColor="var(--darkest-primary)">
            <div title="Fermer">Fermer</div>
          </frg-button>
        </div>
      </ng-container>

      <!-- La connexion avec une carte dans un lecteur wireless a échoué -->
      <ng-container *ngIf="currentState === currentStateTpt.wirelessConnectError">
        <div class="no-card-wrapper">
          <div class="no-card-message">La connexion a un lecteur de carte distant n'a pas pu être établie et renvoi le message suivant :</div>
          <div class="no-card-message">{{ currentStateMessageTpt }}</div>
        </div>
        <div class="button-container center">
          <frg-button (activated)="closeModal()" backgroundColor="var(--darkest-primary)">
            <div title="Fermer">Fermer</div>
          </frg-button>
        </div>
      </ng-container>

      <!-- La connexion avec une carte dans un lecteur wireless a échoué -->
      <ng-container *ngIf="currentState === currentStateTpt.defaultError">
        <div class="no-card-wrapper">
          <div class="no-card-message">L'erreur suivante est survenue' :</div>
          <div class="no-card-message">{{ currentStateMessageTpt }}</div>
        </div>
        <div class="button-container center">
          <frg-button (activated)="closeModal()" backgroundColor="var(--darkest-primary)">
            <div title="Fermer">Fermer</div>
          </frg-button>
        </div>
      </ng-container>

      <ng-container *ngIf="!currentState">
        <div class="no-current-state"></div>
      </ng-container>

    </div>
  </div>

  <!-- Loader -->
  <ng-container *ngIf="isLoading || !currentState">
    <div class="loading-container">
      <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  </ng-container>
</div>
<div class="modal-background"></div>
